// extracted by mini-css-extract-plugin
export default {"header":"Header_header__gmfyh","header_load":"Header_header_load__PyASb","header__title":"Header_header__title__0tbm7","header__subtitle":"Header_header__subtitle__W-ghz"};